
import { Link, useNavigate } from "react-router-dom";
import { sessionRepo } from "data/repositories/sessionRepo";

import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
} from "reactstrap";

const roleLabels = {
  admin: "Yönetici",
  business: "İşletme",
  agency: "Acente",
  guide: "Rehber",
  customer: "Kullanıcı",
};

const AdminNavbar = (props) => {
  const navigate = useNavigate();
  const session = sessionRepo.getSession();

  const displayName = session?.displayName || "Misafir";
  const role = session?.role || "customer";

  const handleLogout = (e) => {
    e.preventDefault();
    sessionRepo.signOut();
    navigate("/auth/login");
  };

  return (
    <>
      <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
        <Container fluid>
          <Link
            className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block"
            to="/"
          >
            {props.brandText}
          </Link>
          <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <FormGroup className="mb-0">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input placeholder="Ara..." type="text" />
              </InputGroup>
            </FormGroup>
          </Form>
          <Nav className="align-items-center d-none d-md-flex" navbar>
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle bg-white d-flex align-items-center justify-content-center">
                    <i className="ni ni-single-02 text-default" style={{ fontSize: "1rem" }} />
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold">
                      {displayName}
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Merhaba, {displayName}!</h6>
                  <small className="text-muted">{roleLabels[role] || role}</small>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#" onClick={handleLogout}>
                  <i className="ni ni-user-run" />
                  <span>Çıkış yap</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
